import { render, staticRenderFns } from "./StudentData.vue?vue&type=template&id=10969f7f&scoped=true"
import script from "./StudentData.vue?vue&type=script&lang=js"
export * from "./StudentData.vue?vue&type=script&lang=js"
import style0 from "./StudentData.vue?vue&type=style&index=0&id=10969f7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10969f7f",
  null
  
)

export default component.exports